<script setup lang="ts">
import { onMounted } from 'vue';
import {
  buildClientModeUrl,
  readBrowserDeviceSignals,
  resolveClientContext,
} from '../context/client-context';

onMounted(() => {
  const decision = resolveClientContext(new URL(window.location.href), readBrowserDeviceSignals());
  window.location.replace(buildClientModeUrl(decision.mode, window.location.href));
});
</script>

<template>
  <main id="main" tabindex="-1" class="client-router-screen" data-client-screen="router">
    <a href="#main" class="skip-link">Saltar al contenido principal</a>
    <div class="client-router-screen__panel">
      <span class="client-router-screen__pulse" aria-hidden="true"></span>
      <p>Preparando experiencia...</p>
    </div>
  </main>
</template>

<style scoped>
.client-router-screen {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background:
    radial-gradient(1000px 420px at 0% 0%, rgba(249, 115, 22, 0.14), transparent 55%),
    linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%);
  color: #172033;
}

.client-router-screen__panel {
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.25rem;
  border: 1px solid #d6dfeb;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.1);
  backdrop-filter: blur(10px);
}

.client-router-screen__panel p {
  margin: 0;
  font-weight: 750;
}

.client-router-screen__pulse {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  background: #ea580c;
  animation: client-router-pulse 1s ease-in-out infinite;
}

@keyframes client-router-pulse {
  50% {
    transform: scale(1.45);
    opacity: 0.45;
  }
}
</style>
